import styled from 'styled-components';

import { colors, ContentWrapper, mobile, tablet } from '../styles';

// The same frame and type scale as the FAQ and How it works pages.
export const Wrapper = styled(ContentWrapper)`
  & > main {
    max-width: 720px;
    margin: 0 auto;
    padding: 40px 44px 60px;

    @media (max-width: ${tablet}) {
      padding: 32px 24px 48px;
    }

    @media (max-width: ${mobile}) {
      padding: 24px 15px 40px;
    }
  }
`;

export const Body = styled.div`
  color: ${colors.defaultText};
  font-size: 16px;
  line-height: 1.6;

  @media (max-width: ${mobile}) {
    font-size: 15px;
  }

  p {
    margin: 0 0 14px;
  }

  a {
    color: ${colors.primaryButton};
  }
`;

export const Intro = styled.p`
  color: ${colors.fadedText};
  margin: 0 0 24px !important;
`;

export const Statements = styled.ol`
  list-style: none;
  margin: 0 0 24px;
  padding: 0;
`;

export const Statement = styled.li`
  border: 1px solid ${colors.lightBorder};
  border-radius: 8px;
  padding: 16px 18px;
  margin: 0 0 12px;
  background: ${colors.whiteBackground};

  fieldset {
    border: 0;
    margin: 0;
    padding: 0;
    min-width: 0;
  }

  legend {
    float: left;
    width: 100%;
    font-size: inherit;
    margin: 0 0 12px;
  }
`;

export const Choices = styled.div`
  clear: both;
  display: flex;
  gap: 10px;
`;

// A radio input styled as a button. The input stays in the page for
// keyboards and screen readers; the label is what people tap.
export const Choice = styled.label`
  position: relative;
  flex: 0 0 96px;
  text-align: center;
  border: 1px solid ${colors.defaultBorder};
  border-radius: 999px;
  padding: 8px 0;
  font-weight: 500;
  font-size: 15px;
  cursor: pointer;
  user-select: none;
  color: ${colors.defaultText};
  background: ${colors.whiteBackground};

  input {
    position: absolute;
    opacity: 0;
    inset: 0;
    margin: 0;
    cursor: pointer;
  }

  &:has(input:checked) {
    border-color: ${colors.primaryButton};
    background: ${colors.primaryButton};
    color: white;
  }

  &:has(input:focus-visible) {
    outline: 2px solid ${colors.primaryButton};
    outline-offset: 2px;
  }
`;

export const PrimaryButton = styled.button`
  display: inline-block;
  font-weight: 500;
  color: white;
  background-color: ${colors.primaryButton};
  font-size: 15px;
  border-radius: 4px;
  padding: 14px 32px;
  border: none;
  min-width: 200px;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  &:hover:not(:disabled) {
    opacity: 0.9;
  }

  @media (max-width: ${mobile}) {
    width: 100%;
  }
`;

export const SecondaryButton = styled(PrimaryButton)`
  color: ${colors.primaryButton};
  background-color: ${colors.whiteBackground};
  border: 1px solid ${colors.primaryButton};
`;

export const ButtonRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin: 0 0 12px;
`;

export const Hint = styled.p`
  color: ${colors.fadedText};
  font-size: 14px;
  margin: 8px 0 0 !important;
`;

export const Small = styled.p`
  color: ${colors.fadedText};
  font-size: 14px;
  margin-top: 28px !important;
`;

export const AccountBox = styled.div`
  border-top: 1px solid ${colors.lightBorder};
  margin-top: 24px;
  padding-top: 20px;
`;

export const NoList = styled.ul`
  margin: 0 0 18px;
  padding-left: 22px;

  li {
    margin: 0 0 8px;
  }
`;
